import {
  UPDATE_REWARD_REQUEST,
  UPDATE_EDIT_REWARD_REQUEST,
  UPDATE_REWARD_REQUEST_TO_LIST,
  UPDATE_REWARD_SELECT_ID,
  CLEAR_REWARD_REQUEST,
  CLEAR_REWARD_SELECT_ID,
  UPDATE_OPEN_MODAL,
  REWARD_TO_INITIAL,
  CLEAR_REQUEST_REWARD_LIST
} from "../actions/types"

const initialState = {
  openModal: false,
  rewardList: [],
  rewardSelectId: null,
  requestRewardDetail: {
    reId: '',
    reName: '',
    reQty: 0,
    reBalance: 0,
    reUsed: 0,
    reType: 1,
    reCampaignId: '',
    reChanceRate: '',
    reIsActive: true,
    reIsRedeem: false,
    startDate: "",
    endDate: "",
    reRedeemCode: "",
    reImgId: "",
    imageDisplay: "",
    backgroundColor: "#FFFFFF"
  }
}

const rewardSettings = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case REWARD_TO_INITIAL:
      return {
        ...state,
        requestRewardDetail: initialState.requestRewardDetail
      }
    case UPDATE_REWARD_REQUEST:
      return {
        ...state,
        requestRewardDetail: {
          ...state.requestRewardDetail,
          [payload.name]: payload.value
        }
      }
    case UPDATE_EDIT_REWARD_REQUEST:
      return {
        ...state,
        requestRewardDetail: {
          ...state.requestRewardDetail,
          ...payload
        }
      }
    case UPDATE_REWARD_REQUEST_TO_LIST:
      return {
        ...state,
        rewardList: payload.rewardList
      }
    case UPDATE_REWARD_SELECT_ID:
      return {
        ...state,
        rewardSelectId: payload
      }
    case CLEAR_REWARD_REQUEST :
      return {
        ...state,
        requestRewardDetail: initialState.requestRewardDetail
      }
    case CLEAR_REWARD_SELECT_ID :
      return {
        ...state,
        rewardSelectId: initialState.rewardSelectId
      }
    case UPDATE_OPEN_MODAL:
      return {
        ...state,
        openModal: payload
      }
    case CLEAR_REQUEST_REWARD_LIST:
      return {
        ...state,
        rewardList: initialState.rewardList,
        requestRewardDetail: initialState.requestRewardDetail
      }
    default:
      return state
  }
}

export default rewardSettings